import { Routes, Route, Navigate } from 'react-router-dom';
// import DashboardPage from './Dashboard';
import SessionsPage from './Sessions';
import PositionsPage from './Positions';
import CreatePositionPage from './CreatePosition';
import ManagePositionPage from './ManagePosition';
import CreateSessionPage from './CreateSession';
import ManageSessionPage from './ManageSession';
import TeamDetailsPage from './TeamDetails';
import ManageTeamPage from './ManageTeam';
import SettingsPage from './Settings';
import BillingPage from './billing/BillingPage';
import SubscriptionForm from './billing/SubscriptionForm';
import { BillingGuard } from '@/components/auth';
import { TeamRedirect } from '@/components/team';
import SessionTemplatesPage from './SessionTemplates';
import ViewSessionPage from './ViewSession';
import CompareCandidatesPage from './CompareCandidates';

export default function AppLayout() {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/app/positions" replace />} />
            <Route path="/positions" element={<PositionsPage nav={true} footer={true} />} />
            <Route path="/positions/create" element={<CreatePositionPage nav={true} footer={true} />} />
            <Route path="/positions/:id/edit" element={<ManagePositionPage nav={true} footer={true} />} />
            <Route path="/positions/:positionId/compare" element={<CompareCandidatesPage />} />
            <Route path="/teams" element={<TeamRedirect />} />
            <Route path="/sessions" element={<SessionsPage nav={true} footer={true} />} />
            <Route path="/sessions/create" element={<CreateSessionPage nav={true} footer={true} />} />
            <Route path="/session-templates" element={<SessionTemplatesPage nav={true} footer={true} />} />
            <Route path="/sessions/:id" element={<ManageSessionPage nav={true} footer={true} />} />
            <Route path="/sessions/:id/view" element={<ViewSessionPage nav={true} footer={false} />} />
            <Route path="/teams/:id" element={<TeamDetailsPage nav={true} footer={true} />} />
            <Route path="/teams/:id/manage" element={<ManageTeamPage nav={true} footer={true} />} />
            <Route path="/settings" element={<SettingsPage nav={true} footer={true} />} />
            <Route path="/billing" element={
                <BillingGuard>
                    <BillingPage />
                </BillingGuard>
            } />
            <Route path="/billing/subscribe/:tier" element={
                <BillingGuard>
                    <SubscriptionForm />
                </BillingGuard>
            } />
            {/* Redirect any unknown app routes to dashboard */}
            <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
    );
}
